// 采购单

import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useSupplierModel } from "../supplierModel";
import { supplierTypeOption } from "@/types/supplierDs";


export function PageHeader() {
    
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useSupplierModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "供应商名称",
            fieldName: "name",
        }, {
            type: SearchTypeEnum.Select,
            placeholder: "供应商类型",
            fieldName: "type",
            options:supplierTypeOption
        },
        
    ]

    return (
        <>
            <YhPageHeader
                title="供应商列表"
                size="small"
                searchValues={searchParam as ISearchValue}
                searchFields={searchFields}
                onChange={updateSearchParam}
                triggerSearch
                handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
                handleReset={resetSearchParam}
            />
        </>
    );
}